export default __webpack_public_path__ + "static/media/retailer-icon.8e4a7af6.svg";